<script>
import * as icons from 'vue-feather-icons'

export default {
  name: 'FeatherIcon',
  functional: true,
  props: {
    icon: {
      required: true,
      type: [String, Object],
    },
    size: {
      type: String,
      default: '14',
    },
    badge: {
      type: [String, Object, Number],
      default: null,
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary',
    },
    color: {
      type: [String],
    },
    opacity: {
      type: [Number, String],
    },
    hoverOpacity: {
      type: [Number, String],
    },
  },
  render(h, { props, data }) {
    // Create Feather Icon
    const style = {}
    if (props.color) style.color = props.color
    if (props.opacity) style['--opacity'] = props.opacity
    if (props.hoverOpacity) style['--hover-opacity'] = props.hoverOpacity

    const svg = h(icons[props.icon], {
      style,
      props: { size: props.size },
      ...data,
    })

    // If no badge is provided => Render just SVG
    if (!props.badge) return svg

    // Badge
    const badgeEl = h(
      'span',
      { staticClass: 'badge badge-up badge-pill', class: props.badgeClasses },
      [props.badge],
    )

    // Return span with children
    return h('span', { staticClass: 'feather-icon position-relative' }, [
      svg,
      badgeEl,
    ])
  },
}
</script>

<style lang="scss">
svg.feather {
  outline: none;
}
svg.feather {
  opacity: var(--opacity);
  &:hover {
    opacity: var(--hover-opacity);
  }
}
</style>
